import { PageTypePortal } from "@/lib/types";
import type { MemberSetupStepId } from "./member-setup-types";

export const MEMBER_SETUP_STEP_ORDER: MemberSetupStepId[] = [
  "waivers",
  "payment",
  "profile",
  "students",
];

export const MEMBER_SETUP_STEP_META: Record<
  MemberSetupStepId,
  { label: string; title: string; description: string }
> = {
  waivers: {
    label: "Waivers",
    title: "Review & sign waivers",
    description:
      "Sign the studio's terms and policies before enrolling in classes.",
  },
  payment: {
    label: "Payment",
    title: "Add a payment method",
    description:
      "Save a card or bank account for tuition and fees. You'll add it on the Balance page.",
  },
  profile: {
    label: "Profile",
    title: "Confirm your information",
    description: "Make sure your name, address, and phone number are correct.",
  },
  students: {
    label: "Students",
    title: "Students on your account",
    description:
      "Add or review the dancers you'll register for classes.",
  },
};

/**
 * Routes members can access while setup is incomplete.
 * Everything else under /portal/dashboard redirects to Get Started.
 */
export const MEMBER_SETUP_ALLOWED_PATH_PREFIXES = [
  PageTypePortal.GetStarted,
  PageTypePortal.Balance,
  PageTypePortal.Terms,
  PageTypePortal.ProfileSettings,
  PageTypePortal.Students,
  PageTypePortal.Contact,
  PageTypePortal.Notifications,
  PageTypePortal.Resources,
] as const;
